<!-- First riddle-tutorial -->
<script>
	import { uiText } from "../lib/uiText.js";
	export let lang = bg;
	let ui = uiText(lang);
	$: lang, (ui = uiText(lang));

	export let tutorial_state = true;
	let tutorial_focus = "none";

	// let button = false;
	$: document.body.classList[tutorial_state ? "add" : "remove"]("noscroll");
	$: document.body.classList[
		tutorial_state && tutorial_focus == "header" ? "add" : "remove"
	]("ttrl-focus-header"),
		document.body.classList[
			tutorial_state && tutorial_focus == "input" ? "add" : "remove"
		]("ttrl-focus-input"),
		document.body.classList[
			tutorial_state && tutorial_focus == "hints" ? "add" : "remove"
		]("ttrl-focus-hints"),
		document.body.classList[
			tutorial_state && tutorial_focus == "riddle" ? "add" : "remove"
		]("ttrl-focus-riddle"),
		document.body.classList[
			tutorial_state && tutorial_focus == "footer" ? "add" : "remove"
		]("ttrl-focus-footer");
</script>

{#if tutorial_state}
	<div class="tutorial_overlay bg-blue-200 bg-opacity-80"></div>

	<div class="tutorial_overlay_content">
		<!-- NONE -->
		{#if tutorial_focus == "none"}
			<div
				class="content obelisk text-center text-balance text-blue-200 bg-white m-6 p-4 place-self-center font-light max-h-screen overflow-auto"
			>
				<h3>{ui.tutorial_overlay.none.title}</h3>
				<p>{ui.tutorial_overlay.none.subtitle}</p>
				<br />
				<p>
					{ui.tutorial_overlay.none.page_contains}
					<strong>{ui.tutorial_overlay.none.strong1}</strong>{ui
						.tutorial_overlay.none.comma}<strong
						>{ui.tutorial_overlay.none.strong2}</strong
					>{ui.tutorial_overlay.none.and}
					<strong>{ui.tutorial_overlay.none.strong3}</strong>{ui
						.tutorial_overlay.none.if}
					<strong>{ui.tutorial_overlay.none.strong4}</strong>{ui
						.tutorial_overlay.none.page_contains2}
				</p>
				<br />

				<div class="flex place-content-between items-center">
					<p
						class="underline cursor-pointer"
						on:click={() => (tutorial_state = false)}
					>
						{ui.tutorial_overlay.skip}
					</p>

					<button
						title={ui.tutorial_overlay.next}
						style="min-width: max-content;"
						on:click={() =>
							document.getElementById("header").scrollIntoView(
								{
									behavior: "smooth",
									block: "start",
									inline: "nearest",
								},
								(tutorial_focus = "riddle")
							)}>{ui.tutorial_overlay.next}</button
					>
				</div>
			</div>
		{/if}

		<!-- RIDDLE -->

		{#if tutorial_focus == "riddle"}
			<div
				class="content obelisk text-center z-[100] text-balance text-blue-200 bg-white m-6 p-4 place-self-end font-light"
			>
				<h3>{ui.tutorial_overlay.riddle.title}</h3>
				<p>{ui.tutorial_overlay.riddle.subtitle}</p>
				<br />
				<p>
					{ui.tutorial_overlay.riddle.each_riddle}
					<br />{ui.tutorial_overlay.riddle.once_there}
				</p>
				<br />

				<div class="flex place-content-between items-center">
					<p
						class="underline cursor-pointer"
						on:click={() => (tutorial_state = false)}
					>
						{ui.tutorial_overlay.skip}
					</p>

					<button
						title={ui.tutorial_overlay.previous}
						on:click={() => (tutorial_focus = "none")}
						><i class="fa-solid fa-chevron-left"></i></button
					>

					<button
						title={ui.tutorial_overlay.next}
						on:click={() =>
							document.getElementById("input").scrollIntoView(
								{
									behavior: "smooth",
									block: "start",
									inline: "nearest",
								},
								(tutorial_focus = "input")
							)}><i class="fa-solid fa-chevron-right"></i></button
					>
				</div>
			</div>
		{/if}

		<!-- INPUT -->

		{#if tutorial_focus == "input"}
			<div
				class="content obelisk text-center z-[100] text-balance text-blue-200 bg-white m-6 p-4 place-self-end font-light"
			>
				<h3>{ui.tutorial_overlay.input.title}</h3>
				<p>{ui.tutorial_overlay.input.subtitle}</p>
				<br />
				<p>
					{ui.tutorial_overlay.input.some_enough}

					<br />
					{ui.tutorial_overlay.input.some_exceptional}
				</p>
				<br />

				<div class="flex place-content-between items-center">
					<p
						class="underline cursor-pointer"
						on:click={() => (tutorial_state = false)}
					>
						{ui.tutorial_overlay.skip}
					</p>

					<button
						title={ui.tutorial_overlay.previous}
						on:click={() =>
							document.getElementById("header").scrollIntoView(
								{
									behavior: "smooth",
									block: "start",
									inline: "nearest",
								},
								(tutorial_focus = "riddle")
							)}><i class="fa-solid fa-chevron-left"></i></button
					>

					<button
						title={ui.tutorial_overlay.next}
						on:click={() =>
							document.getElementById("hints").innerHTML === ""
								? document.getElementById("header").scrollIntoView(
										{
											behavior: "smooth",
											block: "start",
											inline: "nearest",
										},
										(tutorial_focus = "header")
									)
								: document.getElementById("hints").scrollIntoView(
										{
											behavior: "smooth",
											block: "end",
											inline: "nearest",
										},
										(tutorial_focus = "hints")
									)}><i class="fa-solid fa-chevron-right"></i></button
					>
				</div>
			</div>
		{/if}

		<!-- HINTS -->

		{#if tutorial_focus == "hints"}
			<div
				class="content obelisk text-center z-[100] text-balance text-blue-200 bg-white m-6 p-4 place-self-start font-light"
			>
				<h3>{ui.tutorial_overlay.hints.title}</h3>
				<p>{ui.tutorial_overlay.hints.subtitle}</p>
				<br />
				<p>
					{ui.tutorial_overlay.hints.cost}

					<br />
					{ui.tutorial_overlay.hints.slide}
				</p>
				<br />

				<div class="flex place-content-between items-center">
					<p
						class="underline cursor-pointer"
						on:click={() => (tutorial_state = false)}
					>
						{ui.tutorial_overlay.skip}
					</p>

					<button
						title={ui.tutorial_overlay.previous}
						on:click={() =>
							document.getElementById("input").scrollIntoView(
								{
									behavior: "smooth",
									block: "start",
									inline: "nearest",
								},
								(tutorial_focus = "input")
							)}><i class="fa-solid fa-chevron-left"></i></button
					>

					<button
						title={ui.tutorial_overlay.next}
						on:click={() =>
							document.getElementById("header").scrollIntoView(
								{
									behavior: "smooth",
									block: "start",
									inline: "nearest",
								},
								(tutorial_focus = "header")
							)}><i class="fa-solid fa-chevron-right"></i></button
					>
				</div>
			</div>
		{/if}

		<!-- HEADER -->

		{#if tutorial_focus == "header"}
			<div
				class="content obelisk text-center z-[100] text-balance text-blue-200 bg-white m-6 p-4 place-self-end font-light"
			>
				<h3>{ui.tutorial_overlay.header.title}</h3>
				<p>{ui.tutorial_overlay.header.subtitle}</p>

				<br />
				<p>
					<i class="fa-solid fa-user-xmark"></i>&nbsp;&nbsp;&nbsp; {ui
						.tutorial_overlay.header.xmark}
					<br /><br />
					<i class="fa-solid fa-circle-question"></i>&nbsp;&nbsp;&nbsp; {ui
						.tutorial_overlay.header.question}
					<br /><br />
					<i class="fa-solid fa-language"></i>&nbsp;&nbsp;&nbsp; {ui
						.tutorial_overlay.header.language}
				</p>
				<br />

				<div class="flex place-content-between items-center">
					<p
						class="underline cursor-pointer"
						on:click={() => (tutorial_state = false)}
					>
						{ui.tutorial_overlay.skip}
					</p>

					<button
						title={ui.tutorial_overlay.previous}
						on:click={() =>
							document.getElementById("hints").innerHTML === ""
								? document.getElementById("input").scrollIntoView(
										{
											behavior: "smooth",
											block: "start",
											inline: "nearest",
										},
										(tutorial_focus = "input")
									)
								: document.getElementById("hints").scrollIntoView(
										{
											behavior: "smooth",
											block: "end",
											inline: "nearest",
										},
										(tutorial_focus = "hints")
									)}><i class="fa-solid fa-chevron-left"></i></button
					>

					<button
						title={ui.tutorial_overlay.next}
						on:click={() =>
							document.getElementById("footer").scrollIntoView(
								{
									behavior: "smooth",
									block: "start",
									inline: "nearest",
								},
								(tutorial_focus = "footer")
							)}><i class="fa-solid fa-chevron-right"></i></button
					>
				</div>
			</div>
		{/if}

		<!-- FOOTER -->

		{#if tutorial_focus == "footer"}
			<div
				class="content obelisk text-center z-[100] text-balance text-blue-200 bg-white m-6 p-4 place-self-start font-light"
			>
				<h3>{ui.tutorial_overlay.footer.title}</h3>
				<p>{ui.tutorial_overlay.footer.subtitle}</p>

				<br />
				<p>
					{ui.tutorial_overlay.footer.invite}
				</p>
				<br />

				<div class="flex place-content-between items-center">
					<p
						class="underline cursor-pointer"
						on:click={() => (tutorial_state = false)}
					>
						{ui.tutorial_overlay.skip}
					</p>

					<button
						title={ui.tutorial_overlay.previous}
						on:click={() =>
							document.getElementById("header").scrollIntoView(
								{
									behavior: "smooth",
									block: "start",
									inline: "nearest",
								},
								(tutorial_focus = "header")
							)}><i class="fa-solid fa-chevron-left"></i></button
					>

					<button
						title={ui.tutorial_overlay.next}
						on:click={() => (tutorial_focus = "end")}
						><i class="fa-solid fa-chevron-right"></i></button
					>
				</div>
			</div>
		{/if}

		<!-- END -->
		{#if tutorial_focus == "end"}
			<div
				class="content obelisk text-center text-balance text-blue-200 bg-white m-6 p-4 place-self-center font-light max-h-screen overflow-auto"
			>
				<h3>{ui.tutorial_overlay.all.title}</h3>
				<p>{ui.tutorial_overlay.all.subtitle}</p>
				<br />

				<div class="flex place-content-center items-center">
					<button
						title={ui.tutorial_overlay.all.lets_go}
						on:click={() => (
							document.getElementById("header").scrollIntoView({
								behavior: "smooth",
								block: "start",
								inline: "nearest",
							}),
							(tutorial_focus = "none"),
							(tutorial_state = false)
						)}>{ui.tutorial_overlay.all.lets_go}</button
					>
				</div>
			</div>
		{/if}
	</div>
{/if}

<style>
	:global(.ttrl-focus-input #input) {
		position: relative;
		z-index: 50;
	}

	:global(.ttrl-focus-riddle #riddle) {
		scroll-margin-top: 50px;
		position: relative;
		z-index: 50;
	}

	:global(.ttrl-focus-hints #hints) {
		position: relative;
		z-index: 50;
	}

	:global(.ttrl-focus-header #header) {
		position: relative;
		z-index: 50;
	}

	:global(.ttrl-focus-footer #footer) {
		position: relative;
		z-index: 50;
	}

	* {
		text-wrap: balance;
		transition: all 0.2s ease-in;
	}
	.tutorial_overlay {
		width: 100%;
		height: 100%;
		position: fixed;
		z-index: 50;
		display: grid;
	}

	.tutorial_overlay_content {
		width: 100%;
		height: 100%;
		position: fixed;
		z-index: 55;
		display: grid;
	}

	.content {
		position: absolute;
	}
</style>
